// @flow

import { RestClientAuthenticated } from '../network';
import { turanBaseURL } from '../../utils/urlUtils';

const dynamicKeysApi = {
  fetchAll: () => new RestClientAuthenticated(`${turanBaseURL()}/dynamic-keys`, 'GET').execute(),
  fetchAllCurrencies: () => new RestClientAuthenticated(`${turanBaseURL()}/dynamic-keys/currencies`, 'GET').execute(),
};

export default dynamicKeysApi;
